import { useEffect, useContext, useState } from 'react';
import { context as GoogleOauthContext } from '../view/context/googleOauth';

export const useGoogleOauth = () => {
  const googleOauth = useContext(GoogleOauthContext);
  const [code, setCode] = useState('');

  const onAuthorized = async (callback: (code: string) => any) => {
    const { code } = await googleOauth.authenticate();
    callback(code!);
  };
  const authenticate = async (): Promise<void> => {
    const { code } = await googleOauth.authenticate();
    if (code) return setCode(code);
    throw new Error("Google authentication didn't return code");
  };

  useEffect(() => {
    // GoogleAuth.isSignedIn 周りの確認はそのうちしそう
  }, []);

  return { code, authenticate, onAuthorized };
};
